import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Logo } from "../components/Logo";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("wanm_token", data.token);
      nav("/admin/dashboard");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-wanm-offwhite grain px-5">
      <div className="relative z-10 w-full max-w-md bg-white rounded-3xl p-10 shadow-[0_20px_60px_rgba(53,53,53,0.1)]">
        <Logo variant="primary" height={40} to="/" />
        <h1 className="mt-8 text-3xl font-black text-wanm-dark">Admin</h1>
        <form onSubmit={submit} className="mt-8 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-bold uppercase tracking-widest text-wanm-dark/50 mb-2">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email"
              className="w-full bg-transparent border-b-2 border-wanm-dark/20 py-2.5 focus:outline-none focus:border-wanm-pink transition-colors" />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-widest text-wanm-dark/50 mb-2">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password"
              className="w-full bg-transparent border-b-2 border-wanm-dark/20 py-2.5 focus:outline-none focus:border-wanm-pink transition-colors" />
          </div>
          {err && <p className="text-wanm-red text-sm font-bold" data-testid="admin-error">{err}</p>}
          <button type="submit" disabled={loading} data-testid="admin-submit"
            className="w-full wanm-gradient-bg text-white font-bold rounded-full py-3.5 hover:scale-[1.02] transition-transform disabled:opacity-60">
            {loading ? "…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
